import { render } from "./DjiOutBoundOrderPick.vue?vue&type=template&id=1ca925bb&scoped=true"
import script from "./DjiOutBoundOrderPick.vue?vue&type=script&lang=js"
export * from "./DjiOutBoundOrderPick.vue?vue&type=script&lang=js"

import "./DjiOutBoundOrderPick.vue?vue&type=style&index=0&id=1ca925bb&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca925bb"]])

export default __exports__